// Club cart drawer. It never links to /cart, which would drop the shopper into the main store.
(function () {
  var root = document.querySelector('[data-clubcart]');
  if (!root) return;

  var body = root.querySelector('[data-clubcart-body]');
  var foot = root.querySelector('[data-clubcart-foot]');
  var subtotalEl = root.querySelector('[data-clubcart-subtotal]');
  var taxBox = root.querySelector('[data-clubcart-tax]');
  var taxEl = root.querySelector('[data-clubcart-tax-amount]');
  var totalEl = root.querySelector('[data-clubcart-total]');
  var taxLater = root.querySelector('[data-clubcart-tax-later]');
  var taxAsked = 0;

  // The estimate uses Ontario's rates, so only shoppers Cloudflare places in Ontario see it.
  function inOntario() {
    return /(?:^|;\s*)snc_region=CA-ON(?:;|$)/.test(document.cookie);
  }
  function showEstimate(on) {
    taxBox.hidden = !on;
    if (taxLater) taxLater.hidden = on;
    foot.classList.toggle('has-tax', on);
  }
  var counts = document.querySelectorAll('.snc-clubhd__count');
  var lastFocus = null;

  function isAddon(it) { return /^addon-/.test(it.handle || ''); }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function countOf(cart) {
    return cart.items.reduce(function (n, it) { return isAddon(it) ? n : n + it.quantity; }, 0);
  }

  function setCount(n) {
    counts.forEach(function (c) { c.textContent = n; });
  }

  var lastCart = null;
  var panel = root.querySelector('.snc-clubcart__panel') || root;
  var ALSO = panel.getAttribute('data-also-printed') || 'Also printed:';
  var SIZES_FOR = panel.getAttribute('data-sizes-for') || 'Sizes for [count] items';
  var PRINTS = panel.getAttribute('data-prints') || '[count] prints';
  var ONE_PRINT = panel.getAttribute('data-one-print') || '1 print';
  var PRINTING = panel.getAttribute('data-printing') || 'printing';
  var REMOVE = panel.getAttribute('data-remove') || 'Remove';
  var PLAYER_KEYS = ['Team', 'Number', 'Name', 'Players'];
  var SVG = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICON_EDIT = SVG + '<path d="M4 20h4L19 9l-4-4L4 16v4z"/><path d="M13.5 6.5l4 4"/></svg>';
  var ICON_BIN = SVG + '<path d="M4 7h16"/><path d="M9 7V4h6v3"/><path d="M6 7l1 13h10l1-13"/><path d="M10 11v6M14 11v6"/></svg>';
  var ICON_DOWN = SVG + '<path d="M6 9l6 6 6-6"/></svg>';
  var openFolds = {};
  function fill(text, n) { return String(text).split('[count]').join(n); }
  var ON = panel.getAttribute('data-printed-on') || 'on';
  var EDIT = panel.getAttribute('data-edit') || 'Edit';
  var ADD_MORE = panel.getAttribute('data-add-player') || '+ Add another [title]';

  // Theme packages only: the package app's own builder lines carry _package_fields.
  function isPackage(it) { var p = it.properties || {}; return !isAddon(it) && !!p._package && (!p._package_fields || !!p._package_items); }
  function pageOf(it) { return String(it.url || '').split('?')[0]; }
  function editUrl(it) {
    var url = String(it.url || '');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'edit=' + encodeURIComponent(it.key);
  }

  // Prints are their own lines (always charged) but share their package's _group, so they show inside its card.
  function printsByGroup(items) {
    var owners = {};
    items.forEach(function (it) {
      var g = it.properties && it.properties._group;
      if (g && !isAddon(it)) owners[g] = true;
    });
    var kids = {};
    items.forEach(function (it) {
      var g = it.properties && it.properties._group;
      if (g && isAddon(it) && owners[g]) (kids[g] = kids[g] || []).push(it);
    });
    return kids;
  }
  function printText(it) {
    var p = it.properties || {};
    var value = p.Number || p.Name || '';
    var on = p['Printed on'] || '';
    return esc(value) + (on ? ' ' + esc(ON) + ' ' + esc(on) : '');
  }

  // The warehouse reads printing from a note on the order, one line per package, so the pick
  // list needs no line per player. The packing slip and emails read the same Printing attribute.
  function printingLines(cart) {
    var kids = printsByGroup(cart.items);
    var out = [];
    var any = false;
    cart.items.forEach(function (it) {
      if (isAddon(it)) return;
      var p = it.properties || {};
      var bits = [];
      if (p.Number) bits.push('No. ' + p.Number);
      if (p.Name) bits.push('Name ' + p.Name);
      if (!isPackage(it) && !bits.length) return;
      if (bits.length) any = true;
      var parts = [bits.length ? bits.join(' + ') : 'No printing'];
      if (p.Team) parts.push('Team ' + p.Team);
      ((p._group && kids[p._group]) || []).forEach(function (x) {
        var q = x.properties || {};
        var v = q.Number ? 'No. ' + q.Number : q.Name ? 'Name ' + q.Name : '';
        if (!v || !q['Printed on']) return;
        any = true;
        parts.push('Extra ' + v + ' on ' + q['Printed on']);
      });
      var title = isPackage(it) ? it.product_title : it.product_title + ' (' + (it.variant_title || '') + ')';
      out.push(String(title).replace(/[|:]/g, ' ') + ': ' + parts.join('; ').replace(/\|/g, '/'));
    });
    return any ? out : [];
  }

  var printingPending = null;
  var printingSent = null;
  function syncPrinting(cart) {
    var lines = printingLines(cart);
    var value = lines.join(' | ');
    var ours = !cart.note || /^PRINTING/.test(cart.note);
    var note = lines.length ? 'PRINTING\n' + lines.join('\n') : '';
    var have = (cart.attributes && cart.attributes.Printing) || '';
    if (value === have && (!ours || (cart.note || '') === note)) return Promise.resolve();
    var wanted = value + '\u0000' + note;
    if (printingSent === wanted && printingPending) return printingPending;
    printingSent = wanted;
    var body = { attributes: { Printing: value } };
    if (ours) body.note = note;
    printingPending = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error('printing note failed'); })
      .catch(function () { printingSent = null; });
    return printingPending;
  }

  function render(cart) {
    lastCart = cart;
    if (cart.items.length) syncPrinting(cart);
    setCount(countOf(cart));
    if (!cart.items.length) {
      body.innerHTML = '<p class="snc-clubcart__empty">Your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    var kids = printsByGroup(cart.items);
    body.innerHTML = cart.items.map(function (it) {
      var g = it.properties && it.properties._group;
      if (g && isAddon(it) && kids[g] && kids[g].indexOf(it) > -1) return '';
      var prints = (g && !isAddon(it) && kids[g]) || [];
      // Packages have no photo of their own, so they show the club crest like the package page does.
      var photo = it.image || (isPackage(it) && cart.attributes && cart.attributes._club_logo) || '';
      var img = photo
        ? '<img class="snc-clubcart__thumb' + (it.image ? '' : ' is-crest') + '" src="' + esc(photo) + '" alt="" width="44" height="44" loading="lazy">'
        : '';
      var itemPhotos = itemImages[it.handle] || {};
      var props = Object.keys(it.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; });
      var player = props.filter(function (k) { return PLAYER_KEYS.indexOf(k) > -1; });
      var sizes = props.filter(function (k) { return PLAYER_KEYS.indexOf(k) < 0; });
      var line = function (k) { return '<span class="snc-clubcart__variant">' + esc(k) + ': ' + esc(it.properties[k]) + '</span>'; };
      var sizeLine = function (k) {
        var pic = itemPhotos[k];
        return '<span class="snc-clubcart__size">' +
          (pic ? '<img src="' + esc(pic) + '" alt="" width="28" height="28" loading="lazy">' : '<span class="snc-clubcart__size-blank"></span>') +
          '<span>' + esc(k) + ': <b>' + esc(it.properties[k]) + '</b></span></span>';
      };
      var printsTotal = prints.reduce(function (n, p) { return n + p.final_line_price; }, 0);
      var printsHtml = prints.length
        ? '<div class="snc-clubcart__prints">' +
            '<span class="snc-clubcart__prints-title">' + esc(ALSO) + '</span>' +
            prints.map(function (p) {
              return '<div class="snc-clubcart__print">' +
                '<span>' + esc(p.product_title) + ' ' + printText(p) + '</span>' +
                '<span class="snc-clubcart__print-price">+' + (p.quantity > 1 ? p.quantity + ' &times; ' : '') + money(p.final_price) +
                  ' <button type="button" class="snc-clubcart__remove snc-clubcart__print-remove" data-clubcart-remove="' + esc(p.key) + '" data-clubcart-qty="0" aria-label="Remove ' + esc(p.product_title) + ' ' + printText(p) + '">&times;</button>' +
                '</span>' +
              '</div>';
            }).join('') +
          '</div>'
        : '';
      // Long packages fold their sizes and prints away, so a cart of several players stays short.
      var fold = sizes.length > 2 || prints.length > 0;
      var foldLabel = [
        sizes.length ? fill(SIZES_FOR, sizes.length) : '',
        prints.length ? fill(prints.length === 1 ? ONE_PRINT : PRINTS, prints.length) : ''
      ].filter(Boolean).join(' · ');
      var details = fold
        ? '<details class="snc-clubcart__fold" data-fold="' + esc(it.key) + '"' + (openFolds[it.key] ? ' open' : '') + '>' +
            '<summary><span>' + esc(foldLabel) + '</span>' + ICON_DOWN + '</summary>' +
            '<div class="snc-clubcart__fold-body">' + sizes.map(isPackage(it) ? sizeLine : line).join('') + printsHtml + '</div>' +
          '</details>'
        : sizes.map(line).join('');
      // The photo sits in the title row only, so the sizes and prices below use the full width.
      return '<div class="snc-clubcart__item">' +
        '<div class="snc-clubcart__info">' +
          '<div class="snc-clubcart__top">' +
            img +
            '<span class="snc-clubcart__heading">' +
              '<span class="snc-clubcart__name">' + esc(it.product_title) + '</span>' +
              (it.variant_title ? '<span class="snc-clubcart__variant">' + esc(it.variant_title) + '</span>' : '') +
              player.map(line).join('') +
            '</span>' +
            (prints.length ? '<span class="snc-clubcart__top-price">' + money(it.final_line_price + printsTotal) + '</span>' : '') +
          '</div>' +
          details +
          '<div class="snc-clubcart__line">' +
            '<span>' + it.quantity + ' &times; ' + money(it.final_price) +
              (printsTotal ? ' <span class="snc-clubcart__plus">+ ' + money(printsTotal) + ' ' + esc(PRINTING) + '</span>' : '') +
            '</span>' +
            // Packages with the same sizes share a line, so a line of 2 or more can drop just one.
            '<span class="snc-clubcart__actions">' +
              (isPackage(it) && it.url ? '<a class="snc-clubcart__icon" href="' + esc(editUrl(it)) + '" aria-label="' + esc(EDIT) + ': ' + esc(it.product_title) + '" title="' + esc(EDIT) + '">' + ICON_EDIT + '</a>' : '') +
              (it.quantity > 1
                ? '<button type="button" class="snc-clubcart__remove" data-clubcart-remove="' + esc(it.key) + '" data-clubcart-qty="' + (it.quantity - 1) + '">Remove one</button>'
                : '') +
              '<button type="button" class="snc-clubcart__icon snc-clubcart__icon--bin" data-clubcart-remove="' + esc(it.key) + '" data-clubcart-qty="0" aria-label="' + esc(REMOVE) + ': ' + esc(it.product_title) + '" title="' + esc(REMOVE) + '">' + ICON_BIN + '</button>' +
            '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('') + morePlayers(cart.items);
    subtotalEl.textContent = money(cart.total_price);
    foot.hidden = false;
    estimateTax(cart);
    loadItemImages(cart);
  }

  // Item photos come from a small theme section, once per package, then the cart draws again.
  var itemImages = {};
  function loadItemImages(cart) {
    var missing = cart.items.some(function (it) { return isPackage(it) && !itemImages[it.handle]; });
    if (!missing) return;
    fetch(window.location.pathname + '?sections=sannico-cart-images')
      .then(function (r) { return r.json(); })
      .then(function (out) {
        var m = /<script[^>]*data-cart-images[^>]*>([\s\S]*?)<\/script>/.exec((out && out['sannico-cart-images']) || '');
        var found = m ? JSON.parse(m[1]) : {};
        cart.items.forEach(function (it) { if (isPackage(it)) itemImages[it.handle] = found[it.handle] || {}; });
        if (lastCart === cart) render(cart);
      })
      .catch(function () {});
  }

  // Shopify only works out tax at checkout, so the theme estimates it the same way checkout splits packages.
  function estimateTax(cart) {
    if (!taxBox) return;
    var asked = ++taxAsked;
    if (!inOntario()) { showEstimate(false); return; }
    fetch(window.location.pathname + '?sections=sannico-cart-tax')
      .then(function (r) { return r.json(); })
      .then(function (out) {
        if (asked !== taxAsked) return;
        var m = /<script[^>]*data-cart-tax[^>]*>([\s\S]*?)<\/script>/.exec((out && out['sannico-cart-tax']) || '');
        var est = m ? JSON.parse(m[1]) : null;
        if (!est || est.subtotal !== cart.total_price) throw new Error('stale');
        taxEl.textContent = money(est.tax);
        totalEl.textContent = money(cart.total_price + est.tax);
        showEstimate(true);
      })
      .catch(function () {
        if (asked !== taxAsked) return;
        showEstimate(false);
      });
  }

  function morePlayers(items) {
    var seen = {};
    var pages = items.filter(function (it) {
      var page = pageOf(it);
      if (!isPackage(it) || !page || seen[page]) return false;
      seen[page] = true;
      return true;
    });
    return pages.map(function (it) {
      var label = ADD_MORE.split('[title]').join(it.product_title);
      return '<a class="snc-clubcart__more" href="' + esc(pageOf(it)) + '">' + esc(label) + '</a>';
    }).join('');
  }

  // Remember which packages are open, so removing a print does not fold them shut.
  body.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('[data-fold]')) openFolds[d.getAttribute('data-fold')] = d.open;
  }, true);

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    refresh();
    var closeBtn = root.querySelector('[data-clubcart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    root.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.querySelectorAll('[data-clubcart-open]').forEach(function (b) {
    b.addEventListener('click', open);
  });
  root.querySelectorAll('[data-clubcart-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) close();
  });

  // Removing a package or item also removes its prints (same _group).
  body.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-clubcart-remove]');
    if (!btn) return;
    btn.disabled = true;
    var key = btn.getAttribute('data-clubcart-remove');
    var qty = parseInt(btn.getAttribute('data-clubcart-qty'), 10) || 0;
    var updates = {};
    updates[key] = qty;
    var line = lastCart && lastCart.items.filter(function (it) { return it.key === key; })[0];
    var group = line && !isAddon(line) && line.properties && line.properties._group;
    if (group) {
      lastCart.items.forEach(function (it) {
        if (it.key !== key && isAddon(it) && it.properties && it.properties._group === group) {
          updates[it.key] = line.quantity ? Math.round(it.quantity * qty / line.quantity) : 0;
        }
      });
    }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(render)
      .catch(function () { btn.disabled = false; });
  });

  // The note must be on the cart before checkout makes the order, so checkout waits for it (a few seconds at most).
  root.addEventListener('click', function (e) {
    var link = e.target.closest('.snc-clubcart__checkout');
    if (!link) return;
    e.preventDefault();
    var gone = false;
    var go = function () { if (gone) return; gone = true; location.href = link.href; };
    setTimeout(go, 4000);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(syncPrinting)
      .then(go, go);
  });

  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(countOf(cart)); })
      .catch(function () {});
  });
  document.addEventListener('sannico:cart:open', open);

  // Keep a club product add in the club drawer. Skip the PDP form (pdpSubmitBound): preventDefault
  // does not stop other listeners, so both would add and double the quantity.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.pdpSubmitBound === '1') return;
    e.preventDefault();
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { open(); })
      .catch(function () { form.submit(); });
  });
})();
